/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_TypeInputs */

const en_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulfillment Type`)
};

const es_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de entrega`)
};

const fr_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de livraison`)
};

const de_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abwicklungsart`)
};

const ja_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フルフィルメントタイプ (提供方法)`)
};

const zh_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`履约类型`)
};

const ar_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع التنفيذ (التسليم)`)
};

const id_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Pemenuhan`)
};

const it_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità di Consegna`)
};

const ru_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип выполнения/доставки`)
};

const pt_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Entrega`)
};

const ko_fulfillment_type = /** @type {(inputs: Fulfillment_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제공/배송 방식`)
};

/**
* | output |
* | --- |
* | "Fulfillment Type" |
*
* @param {Fulfillment_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_type = /** @type {((inputs?: Fulfillment_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_type(inputs)
	if (locale === "es") return es_fulfillment_type(inputs)
	if (locale === "fr") return fr_fulfillment_type(inputs)
	if (locale === "de") return de_fulfillment_type(inputs)
	if (locale === "ja") return ja_fulfillment_type(inputs)
	if (locale === "zh") return zh_fulfillment_type(inputs)
	if (locale === "ar") return ar_fulfillment_type(inputs)
	if (locale === "id") return id_fulfillment_type(inputs)
	if (locale === "it") return it_fulfillment_type(inputs)
	if (locale === "ru") return ru_fulfillment_type(inputs)
	if (locale === "pt") return pt_fulfillment_type(inputs)
	return ko_fulfillment_type(inputs)
});